import { MaybeT, createPhantomTypeSchema, t } from '../../../../universal';
import { React, _ } from '../../../lib';
import { Combobox } from '../combobox';
import { readDynamic } from './types';
const MAX_ITEMS_FOR_ENUM = 20;
const getEnumInfo = (options) => {
    const options_flat = options.flatMap(x => {
        if ('options' in x) {
            return x.options.map(y => [y.value, y.text]);
        }
        return [[x.value, x.text]];
    });
    let text_values = options_flat.map(x => x[1]);
    const can_fit_all = text_values.length <= MAX_ITEMS_FOR_ENUM;
    if (!can_fit_all) {
        text_values = _.sampleSize(text_values, MAX_ITEMS_FOR_ENUM);
    }
    return {
        enums: text_values,
        enumsAreComplete: can_fit_all,
        reversal: (value) => {
            if (!_.isArray(value)) {
                return options_flat.find(y => y[1] == value)?.[0];
            }
            return value.map(v => options_flat.find(y => y[1] == v)?.[0]);
        },
    };
};
export const FormTypeDropdown = (settings) => ({
    ...settings,
    lbl: settings.required
        ? formState => `${readDynamic(settings.lbl, formState)}*`
        : settings.lbl,
    valueDefaults: {
        def: () => null,
        validators: (() => {
            const isRequiredValidator = settings.required && {
                req: (v) => v != null,
                msg: 'field is required',
            };
            return _.compact([isRequiredValidator]);
        })(),
    },
    height: 36,
    typeMap: {
        schemaPublic: createPhantomTypeSchema(MaybeT(t.Number())),
        schemaRaw: createPhantomTypeSchema(MaybeT(t.Number())),
        toPublic: x => x,
        toInternal: x => x,
    },
    llmInfo: formState => ({
        stringifiedType: 'string',
        description: readDynamic(settings.doc, formState) ?? readDynamic(settings.lbl, formState),
        ...getEnumInfo(readDynamic(settings.options, formState)),
    }),
    jsx: (props, formState) => (React.createElement(Combobox, { multiple: false, value: props.value, onUpdate: props.onUpdate, className: props.className ?? undefined, title: props.title ?? undefined, options: readDynamic(settings.options, formState), nullable: settings.nullable, placeholder: settings.placeholder, disabled: props.readOnly || props.disabled, autoPickOnly: settings.autoPickOnly ?? true, onFocus: props.onFocus, onBlur: props.onBlur })),
});
export const FormTypeDropdownStringKey = (settings) => ({
    ...settings,
    lbl: settings.required
        ? formState => `${readDynamic(settings.lbl, formState)}*`
        : settings.lbl,
    valueDefaults: {
        def: () => null,
        validators: _.compact([
            settings.required
                ? {
                    req: (value) => value != null,
                    msg: 'field is required',
                }
                : null,
        ]),
    },
    height: 36,
    typeMap: {
        schemaPublic: createPhantomTypeSchema(MaybeT(t.String())),
        schemaRaw: createPhantomTypeSchema(MaybeT(t.String())),
        toPublic: x => x,
        toInternal: x => x,
    },
    llmInfo: formState => ({
        stringifiedType: 'string',
        description: readDynamic(settings.doc, formState) ?? readDynamic(settings.lbl, formState),
        ...getEnumInfo(readDynamic(settings.options, formState)),
    }),
    jsx: (props, formState) => (React.createElement(Combobox, { multiple: false, value: props.value, onUpdate: props.onUpdate, className: props.className ?? undefined, title: props.title ?? undefined, options: readDynamic(settings.options, formState), nullable: settings.nullable, placeholder: settings.placeholder, disabled: props.readOnly || props.disabled, autoPickOnly: settings.autoPickOnly ?? true, onFocus: props.onFocus, onBlur: props.onBlur })),
});
export const FormTypeDropdownMulti = (settings) => ({
    ...settings,
    lbl: settings.required
        ? formState => `${readDynamic(settings.lbl, formState)}*`
        : settings.lbl,
    valueDefaults: {
        def: () => [],
        validators: settings.required
            ? [
                {
                    req: value => value.length > 0 && _.every(value, x => x != null),
                    msg: 'field is required',
                },
            ]
            : [],
    },
    height: 36,
    typeMap: {
        schemaPublic: createPhantomTypeSchema(t.Array(t.Number())),
        schemaRaw: createPhantomTypeSchema(t.Array(t.Number())),
        toPublic: x => x,
        toInternal: x => x,
    },
    llmInfo: formState => ({
        stringifiedType: 'string[]',
        description: readDynamic(settings.doc, formState) ?? readDynamic(settings.lbl, formState),
        ...getEnumInfo(readDynamic(settings.options, formState)),
    }),
    jsx: (props, formState) => (React.createElement(Combobox, { multiple: true, value: props.value, onUpdate: props.onUpdate, className: props.className ?? undefined, title: props.title ?? undefined, options: readDynamic(settings.options, formState), nullable: settings.nullable, placeholder: settings.placeholder, disabled: props.readOnly || props.disabled, autoPickOnly: settings.autoPickOnly ?? true, textView: settings.textView, onFocus: props.onFocus, onBlur: props.onBlur })),
});
export const FormTypeDropdownMultiStringKey = (settings) => ({
    ...settings,
    lbl: settings.required
        ? formState => `${readDynamic(settings.lbl, formState)}*`
        : settings.lbl,
    valueDefaults: {
        def: () => [],
        validators: settings.required
            ? [
                {
                    req: value => value.length > 0 && _.every(value, x => x != null),
                    msg: 'field is required',
                },
            ]
            : [],
    },
    height: 36,
    typeMap: {
        schemaPublic: createPhantomTypeSchema(t.Array(t.String())),
        schemaRaw: createPhantomTypeSchema(t.Array(t.String())),
        toPublic: x => x,
        toInternal: x => x,
    },
    llmInfo: formState => ({
        stringifiedType: 'string[]',
        description: readDynamic(settings.doc, formState) ?? readDynamic(settings.lbl, formState),
        ...getEnumInfo(readDynamic(settings.options, formState)),
    }),
    jsx: (props, formState) => (React.createElement(Combobox, { multiple: true, value: props.value, onUpdate: props.onUpdate, className: props.className ?? undefined, title: props.title ?? undefined, options: readDynamic(settings.options, formState), nullable: settings.nullable, placeholder: settings.placeholder, disabled: props.readOnly || props.disabled, autoPickOnly: settings.autoPickOnly ?? true, textView: settings.textView, onFocus: props.onFocus, onBlur: props.onBlur })),
});
//# sourceMappingURL=fields-dropdown.js.map